import React from 'react';
import PropTypes from 'prop-types';
import {Icon} from 'semantic-ui-react';
import styled from 'styled-components';

const HamburgerButton = styled.div`
  cursor: pointer;
  i {
    color: #ffffff;
    font-size: 40px !important;
    height: 40px !important;
    display: flex !important;
    justify-content: center;
    align-items: center;
    margin: 0;
  }
`;

const MenuButton = ({onClick}) => (
  <HamburgerButton onClick={onClick}>
    <Icon name="sidebar"/>
  </HamburgerButton>
);
MenuButton.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default MenuButton;



// WEBPACK FOOTER //
// ./src/components/Button/MenuButton.js